import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { organizationUnitsService } from '../api/organization-units.service';
import { ORGANIZATION_UNITS_KEYS } from './queryKeys';
import type { CreateOrganizationUnitInput } from '../schemas';

export function useCreateOrganizationUnit() {
  const queryClient = useQueryClient();
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (payload: CreateOrganizationUnitInput) => organizationUnitsService.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ORGANIZATION_UNITS_KEYS.byOrg(activeOrganizationId!),
      });
    },
  });
}
